import React, {Component} from 'react';
import './ConsultoriaEstrategica.css';

export default class ConsultoriaEstrategica extends Component {
    render() {
        return (
            <div className="content">
                <h1 className="titulo">Consultoria Estratégica</h1>
                <ul>
                    <li>Assessoria na Elaboração do Planejamento Estratégico, alinhado com Metodologia “Balanced Scorecard”;</li>
                    <li>Assessoria para Elaboração e Implementação de Planejamento Estratégico e Operacional;</li>
                    <li>Planejamento, Desenvolvimento e Implantação de Gestão com base dos Critérios do PNQ;</li>
                    <li>Assessoria para Elaboração e Implementação de Plano de Viabilidade;</li>
                    <li>Assessoria para Elaboração e Implementação de Plano de Continuidade de Negócios;</li>
                    <li>Assessoria para Elaboração e Implementação de Plano de Contingência;</li>
                    <li>Assessoria para Elaboração e Implementação de Gestão de Riscos;</li>
                    <li>Consultoria em Mapeamento e Redesenho de Processos;</li>
                    <li>Elaboração de Diagnóstico e Análise Crítica da Gestão Organizacional com vistas a Racionalização e Sistematização dos Processos;</li>
                    <li>Auditorias de Processos e Sistemas de Gestão em Gerenciamento de Projetos;</li>
                    <li>Assessoria em Gestão dos Custos da Qualidade;</li>
                    <li>Assessoria na Gestão de Fornecedores;</li>
                    <li>Assessoria na Gestão e Definição de Indicadores de Desempenho;</li>
                    <li>Implantação e Treinamentos em Ferramentas de Gestão da Qualidade, como Controle Estatístico, CEP, MASP, 5S, FMEA, APQP;</li>
                    <li>Implantação de Manutenção Produtiva Total – MPT / TPM;</li>
                    <li>Implantação do World Class Manufacturing(“Lean Thinking”).</li>
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/ConsultoriaEstrategica.js